import { type ChangeEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../../../app/hooks'
import Loading from '../../../../components/Loading/Loading'
import { useLoginMutation } from '../../authApiSlice/authApiSlice'
import { getAdminStatus } from '../../authThunks/authThunks'
import LoginPresentation from '../../presentations/login/login.presentation'
const LoginContainer = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();
  const [login ,{isLoading,isSuccess,isError,error:loginError}] = useLoginMutation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setshowPassword] = useState(false)

  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => { setEmail(e.target.value) }
  const onChangePassword = (e: ChangeEvent<HTMLInputElement>) => { setPassword(e.target.value) }

  const handleClickShowPassword = () => { setshowPassword(!showPassword) }

  const onLogin = async () => {
    try {
      const log: any = await login({
        email:email.toLocaleLowerCase().trim(),
        password
      }).unwrap()
      localStorage.setItem('@jwt-token',log.access_token);
      dispatch(getAdminStatus());
    } catch (error) {
      console.error(error)
      setEmail("");
      setPassword("");
  };
}

useEffect(() => {
   const token = localStorage.getItem('@jwt-token')

   if(token || isSuccess){
    navigate('/')
   }

}, [isSuccess])

  let content
  if (isLoading) {
    content = <Loading />
  }
  content = (
    <LoginPresentation
      email={email}
      password={password}
      onChangeEmail={onChangeEmail}
      onChangePassword={onChangePassword}
      onLogin={onLogin}
      handleClickShowPassword={handleClickShowPassword}
      showPassword={showPassword}
      isError={isError}
      error={loginError}
    />
  )

  return <>{content}</>
}

export default LoginContainer
